import { render, staticRenderFns } from "./GeneralCultureGoFurther.vue?vue&type=template&id=a240480e&"
import script from "./GeneralCultureGoFurther.vue?vue&type=script&lang=ts&"
export * from "./GeneralCultureGoFurther.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralCultureGoFurther.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports